module.exports = __webpack_public_path__ + "img/brillante_6.c49877be.svg";